(function initHanezzaBentoQualityFixes(root) {
  'use strict';

  if (!root || !root.document) return;

  var doc = root.document;
  var observer = null;
  var observerTimer = null;

  function isBentoPage() {
    try {
      return new URLSearchParams(root.location.search).get('view') === 'bento' || Boolean(doc.querySelector('.bento-collection'));
    } catch (_) {
      return Boolean(doc.querySelector('.bento-collection'));
    }
  }

  function ensureTouchTargetStyles() {
    if (doc.getElementById('hanezza-bento-quality-styles')) return;

    var style = doc.createElement('style');
    style.id = 'hanezza-bento-quality-styles';
    style.textContent = [
      '.bento-img-dots{display:flex;align-items:center;justify-content:center;gap:0;}',
      '.bento-img-dot{box-sizing:border-box!important;width:32px!important;height:32px!important;min-width:32px!important;min-height:32px!important;margin:0!important;padding:0!important;border:0!important;background:transparent!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;position:relative!important;cursor:pointer;}',
      '.bento-img-dot::before{content:"";display:block;width:6px;height:6px;border-radius:9999px;background:#d1d5db;transition:width .2s ease,background-color .2s ease;}',
      '.bento-img-dot.active::before{width:16px;background:#7b2c84;}',
      '.bento-img-dot:focus-visible{outline:2px solid #7b2c84;outline-offset:-4px;border-radius:9999px;}'
    ].join('');
    doc.head.appendChild(style);
  }

  function firstFollowing(container, selector) {
    var nodes = Array.prototype.slice.call(doc.querySelectorAll(selector));
    if (!nodes.length) return null;
    if (!container) return nodes[nodes.length - 1];

    return nodes.find(function (node) {
      return Boolean(container.compareDocumentPosition(node) & root.Node.DOCUMENT_POSITION_FOLLOWING);
    }) || nodes[nodes.length - 1];
  }

  function renameElement(element, id) {
    if (!element) return null;
    if (element.id !== id) element.id = id;
    return element;
  }

  function normalizeDuplicateIds(id) {
    var nodes = Array.prototype.slice.call(doc.querySelectorAll('[id="' + id + '"]'));
    if (nodes.length < 2) return;

    nodes.slice(1).forEach(function (element, index) {
      element.id = id + '-hanezza-' + (index + 2);
    });
  }

  function fixBentoDrawerIds() {
    var bento = doc.querySelector('.bento-collection');
    if (!bento) return;

    var overlay = renameElement(firstFollowing(bento, '#stitch-drawer-overlay, #bento-stitch-drawer-overlay'), 'bento-stitch-drawer-overlay');
    var drawer = firstFollowing(bento, '#stitch-filter-drawer');
    var close = renameElement(firstFollowing(bento, '#stitch-drawer-close, #bento-stitch-drawer-close'), 'bento-stitch-drawer-close');
    var sort = firstFollowing(bento, '#stitch-sort-dropdown');

    if (!overlay || !drawer || !sort) return;

    var buttons = Array.prototype.slice.call(bento.querySelectorAll('.bento-filter-bar button'));
    var filterButton = bento.querySelector('.bento-filter-bar .bento-pill-dark');
    var sortButton = buttons.find(function (button) {
      return /sırala/i.test(String(button.textContent || ''));
    });

    function setState(type, open) {
      var filterOpen = type === 'filter' && open;
      var sortOpen = type === 'sort' && open;
      drawer.classList.toggle('open', filterOpen);
      sort.classList.toggle('open', sortOpen);
      overlay.classList.toggle('open', Boolean(open));
      drawer.setAttribute('aria-hidden', filterOpen ? 'false' : 'true');
      sort.setAttribute('aria-hidden', sortOpen ? 'false' : 'true');
      overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (filterButton) filterButton.setAttribute('aria-expanded', filterOpen ? 'true' : 'false');
      if (sortButton) sortButton.setAttribute('aria-expanded', sortOpen ? 'true' : 'false');
    }

    if (filterButton && filterButton.dataset.hanezzaBentoBound !== 'true') {
      filterButton.removeAttribute('onclick');
      filterButton.dataset.hanezzaBentoBound = 'true';
      filterButton.setAttribute('aria-controls', drawer.id);
      filterButton.setAttribute('aria-expanded', drawer.classList.contains('open') ? 'true' : 'false');
      filterButton.addEventListener('click', function () { setState('filter', true); });
    }

    if (sortButton && sortButton.dataset.hanezzaBentoBound !== 'true') {
      sortButton.removeAttribute('onclick');
      sortButton.dataset.hanezzaBentoBound = 'true';
      sortButton.setAttribute('aria-controls', sort.id);
      sortButton.setAttribute('aria-expanded', sort.classList.contains('open') ? 'true' : 'false');
      sortButton.addEventListener('click', function () {
        setState('sort', !sort.classList.contains('open'));
      });
    }

    if (close && close.dataset.hanezzaBentoBound !== 'true') {
      close.dataset.hanezzaBentoBound = 'true';
      close.setAttribute('type', 'button');
      close.setAttribute('aria-label', close.getAttribute('aria-label') || 'Filtreleri kapat');
      close.addEventListener('click', function () { setState(null, false); });
    }

    if (overlay.dataset.hanezzaBentoBound !== 'true') {
      overlay.dataset.hanezzaBentoBound = 'true';
      overlay.addEventListener('click', function () { setState(null, false); });
    }

    setState(null, false);
  }

  function fixHelpLink() {
    var link = doc.getElementById('sf-help-link');
    if (!link || String(link.getAttribute('href') || '').trim() !== '#') return;

    link.removeAttribute('href');
    link.setAttribute('role', 'button');
    link.setAttribute('tabindex', '0');
    if (link.dataset.hanezzaKeyboardBound === 'true') return;

    link.dataset.hanezzaKeyboardBound = 'true';
    link.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        link.click();
      }
    });
  }

  function applyFixes() {
    if (!isBentoPage()) return;
    ensureTouchTargetStyles();
    fixBentoDrawerIds();
    normalizeDuplicateIds('Layer_1');
    normalizeDuplicateIds('contact_form');
    fixHelpLink();
  }

  root.HanezzaBentoQualityFixes = { apply: applyFixes };

  function boot() {
    applyFixes();

    if (observer) return;
    observer = new MutationObserver(function () {
      root.clearTimeout(observerTimer);
      observerTimer = root.setTimeout(applyFixes, 40);
    });
    observer.observe(doc.documentElement, { childList: true, subtree: true });
    root.setTimeout(function () {
      if (observer) observer.disconnect();
      observer = null;
    }, 15000);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})(typeof window !== 'undefined' ? window : null);
